import { Injectable } from '@angular/core';
import {StorageService} from "./storage.service";

@Injectable({
  providedIn: 'root'
})
export class AppUtilsService {

  constructor() { }

  compareArrays(arr1: number[], arr2: number[]): boolean {
    if (arr1.length !== arr2.length) {
      return false;
    }

    const sortedArr1 = arr1.slice().sort();
    const sortedArr2 = arr2.slice().sort();

    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }

    return true;
  }


  flattenItems(items: any) {
    const flattenedItems: any = [];

    function flattenObject(obj: any, prefix = '') {
      for (const key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          flattenObject(obj[key], `${prefix}${key}.`);
        } else {
          flattenedItems[`${prefix}${key}`] = obj[key];
        }
      }
    }

    for (const item of items) {
      flattenObject(item);
    }

    return flattenedItems;
  }

  validateEmail(email: string): boolean {
    // Expression régulière pour valider une adresse e-mail.
    const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  getDepValue(item: any, path: any) {
    // Diviser le chemin en un tableau de propriétés
    const tabPath = path.split('.');

    // Supprimer '_id' de chaque élément du tableau de chemin
    for (let i = 0; i < tabPath.length; i++) {
      tabPath[i] = tabPath[i].replace('_id', '');
    }

    // Initialiser la valeur en tant qu'objet d'origine
    let value = item;

    // Parcourir le tableau de chemin et obtenir la valeur de chaque propriété
    for (const pathItem of tabPath) {
      // Vérifier si la valeur est définie et non nulle avant d'accéder à la propriété suivante
      if (value && typeof value === 'object') {
        value = value[pathItem];
      } else {
        // Si la valeur est indéfinie ou nulle, retourner undefined
        return undefined;
      }
    }

    // Retourner la valeur finale
    return value;
  }
}
